import React, {useCallback} from 'react'
import ListItem, {BaseProps} from './ListItem'
import {ColInfo, ColPhoto, ColStat} from '../Col'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'
import Button from '../../Button/Button'
import {formatDate} from '../../../utils/date'
import {User} from './CommentsItem'
import {formatNumber} from '../../../utils/number'
import {useNavigation} from '../../../utils/navigation'

type Props = {
  readonly user: Readonly<User>
  readonly onApprove: () => void
  readonly onBlock: () => void
  readonly onDelete: () => void
} & BaseProps

const UserItem: React.VFC<Props> = ({
  onSelected,
  selected,
  options,
  user,
  onApprove,
  onBlock,
}) => {
  const {goTo} = useNavigation()

  const navigateToUser = useCallback(() => {
    // goTo(Routes.EditUser, { id: user.id })
  }, [])

  const isPending = !user.blocked && !user.trusted

  return (
    <ListItem
      onClick={navigateToUser}
      onSelected={onSelected}
      selected={selected}
      options={options}>
      <ColPhoto>
        <div
          className={styles.Avatar}
          style={{backgroundImage: `url(${user.avatar})`}}
        />
      </ColPhoto>
      <ColInfo>
        <p className={classNames([styles.InfoBig, styles.Ellipsis])}>
          {user.displayName}
        </p>
        <p className={classNames([styles.InfoSmall, styles.Ellipsis])}>
          <b>Username: {user.name}</b> | Email: EMAIL NEEDED
        </p>

        <div className={styles.ButtonBlock}>
          <Button
            onClick={onApprove}
            additionalClassNames={[
              styles.ButtonCombo,
              styles.IconAdminApprove,
              ...(user.trusted ? [styles.IconAdminApproved] : []),
            ]}>
            Approve
          </Button>
          <Button
            onClick={onBlock}
            additionalClassNames={[
              styles.ButtonCombo, 
              styles.IconAdminBlock,
              ...(user.blocked ? [styles.IconAdminBlocked] : [])
            ]}>
            Ban
          </Button>
        </div>

      </ColInfo>
      <ColStat>{(isPending ? 'Pending' : user.blocked ? 'Disabled' : 'Enabled')}</ColStat>
    </ListItem>
  )
}

export default UserItem
